import React from "react";
import OPOfflineIframe from "../../../iframe-component/operation-offline/OPOffIframe";

const MassEmail = () => {
  return <OPOfflineIframe path="/operation/mail" />;
};

export default React.memo(MassEmail);
